// extracted by mini-css-extract-plugin
export default {"block":"C4QjO","inlineParagraph":"Do87o","hidden":"TSjcI","button":"apSLg","chevron":"hX3Ry","active":"VvG2c"};